module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-04.cb92837f.jpg";